<template>
	<div class="">
		<b-container id="welcome">
			<b-row>
				<b-col>
					<div id="storeLogo" class="text-center mt-4">
					<img class="w-75" src="https://clickandcollect.scanandget-development.co.uk/assets/demo-clothing-store-logo.png"/>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-container id="authenticate" v-if="!authenticated">
			<b-row>
				<b-col class="pt-4"> 
					<div class="mt-4 px-4 text-center">
						<div v-if="showLastFour">
							<p class="text-left">Please enter the last four digits of the mobile number associated with your order</p>
							<b-form class="text-center" >
									<b-form-input
										class="w-25"
										id="lastFour"
										v-model="authForm.lastFour"
										type="text"
										minlength="4"
										maxlength="4"
										required
										
									></b-form-input>
									<b-button variant="success" class="mt-4" @click="authenticate" :disabled="authForm.lastFour.length != 4">Let us know that you are here</b-button>
							</b-form>
						</div>
						<div v-if="showAuthSpinner">
							<b-spinner style="width: 5rem; height: 5rem;" variant="success" class="mb-2"></b-spinner>
							<p class="mt-1">Thank you<br />Contacting the store...</p>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-container id="authenticated" v-if="authenticated">
			<b-row>
				<b-col class="p-4">
					<div class="p-4" v-if="!toEarly">
						<div v-if="identify && !identified">
							<p>Please enter a few details of the vehicle that you are in so that when 
							can quickly locate you when bringing out your order.</p>
							<b-form>
								<b-form-group id="reg-input-group" label="Vehicle Reg:"	label-for="reg-input">
									<b-form-input
									id="reg-input"
									v-model="vehicleForm.reg"
									:state="regState"
									required
									placeholder="Please enter your car registration"
									></b-form-input>
									<b-form-invalid-feedback>At least two characters are requried</b-form-invalid-feedback>
								</b-form-group>

								<b-form-group id="make-group" label="Vehicle Make (or type):" label-for="make-input">
									<b-form-input
									id="make-input"
									v-model="vehicleForm.make"
									:state="makeState"
									required
									placeholder="Please enter your car make"
									></b-form-input>
									<b-form-invalid-feedback>At least two characters are requried</b-form-invalid-feedback>
								</b-form-group>

								<b-form-group id="colour-input-group" label="Vehicle Colour:" label-for="colour-input">
									<b-form-input
									id="colour-input"
									v-model="vehicleForm.colour"
									:state="colourState"
									required
									placeholder="Please enter your car colour"
									></b-form-input>
									<b-form-invalid-feedback>At least three characters are required</b-form-invalid-feedback>
								</b-form-group>

								<b-button variant="primary" @click="identifyVehicle" :disabled="identifyBtn">Confirm</b-button>

							</b-form>
						</div>
						<div v-if="!identify || identified">						
							<p>Hi {{orderDetails.customerName}}</p>
							<p>We are getting your order ref: <strong>{{ orderDetails.orderId }}</strong>  ready.</p>
							<p>{{ customCollectInstructions }}</p>
						</div>
					</div>
					<div class="p-4" v-if="toEarly">
						<p>Hi {{orderDetails.customerName}}</p>
						<p>Sorry our records show that your order ref : <strong>{{ orderDetails.orderId }}</strong>  is 
						not due for collection until:</p>
						<p><strong>Between: </strong>{{ orderDetails.collectionTime}}<br /><strong>On: </strong>{{ orderDetails.collectionDate | moment("dddd D MMMM YYYY")}}</p>
						<p>Please come back at the scheduled time and date.</p>
						<p>If the time and date shown above do not match the time and date confirmed in the text message that you received, please accept our apologies and contact a member of staff in store.</p>
						<p>We are sorry for any inconvenience that may have been caused.</p>
					</div>
				</b-col>
			</b-row>
		</b-container>
		<b-container id="authFailed" v-if="authFailed  && !identified">
			<b-row>
				<b-col class="px-4"><p>We are sorry but we have been unable to locate your order, please check the last four digits of your mobile number were entered correctly.</p>
				<p>You entered  <strong>{{ authForm.lastFour }}</strong> </p>
				<p>Please either click the button below to try again or contact a member of staff at the door or in store.</p>
				<b-button variant="success" class="mt-4" @click="tryAgain">Try again</b-button>							
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import {mixin} from '../mixins/anonymousUserClickAndCollectMixins'
export default{
	name: 'ImHere',
	components: {},
	mixins: [mixin],
	props: ['orderId', 'pin'],
	data(){
		return{
			authenticated: false,
			authFailed: false,
			showAuthSpinner: false,
			toEarly: false,
			identified: false,
			showLastFour: true,
			authForm:{
				lastFour:  "",
				pin: "",
				orderId: ""
			},
			vehicleForm:{
				reg: "abc",
				colour: "red",
				make: "ford"
			},
			orderDetails:{
				customerName: "",
				collectionTime: "",
				collectionDate: "",
				orderId: "" // this is the stores order id
			}
		}
	},
	created(){
		//let orderId = '1-1594050293';
		// let pin = 5214;
		this.getStoreSettings(this.orderId.slice(0, 1));
	},
	methods: {
		async authenticate()
		{			
			this.showLastFour = false
			this.showAuthSpinner = true
			console.log("api authentication call")
			console.log(this.$store.state.settings)
			this.getOrder(this.orderId, this.pin, this.authForm.lastFour, this.$store.state.settings.notificationTel,
			this.$store.state.settings.notificationEmail, this.$store.state.settings.identifyType, this.orderId.slice(0, 1))
			setTimeout(() => {				
				if(this.authenticated){
					this.showAuthSpinner = false					
				}
				else
				{
					this.showAuthSpinner = false
					this.authFailed = true			
				}
			}, 3000)			
		},
		async identifyVehicle()
		{			
			this.identify = false
			this.authFailed = false	
			this.identified = true
			this.updateIdentify(this.orderId, this.$store.state.settings.identifyType, this.vehicleForm.reg, this.vehicleForm.make,
			this.vehicleForm.colour, this.orderId.slice(0, 1) , this.$store.state.settings.identifyType,
			this.$store.state.settings.notificationTel, this.orderDetails.orderId, this.orderDetails.customerName,
			this.$store.state.settings.notificationEmail)
			this.$nextTick().then(() => {
				this.authenticated = false
				this.showAuthSpinner = true
				console.log("update Car details api call")				
				setTimeout(() => {
					this.authenticated = true
					this.showAuthSpinner = false
					
				}, 3000)
			});
		},
		tryAgain(){
			this.showLastFour = true
			this.authFailed = false
			this.authForm.lastFour = ""
		}
	},
	computed: {
		regState(){
			return (this.vehicleForm.reg.length >= 2)? true: false
		},
		makeState(){
			return (this.vehicleForm.make.length >= 2)? true: false
		},
		colourState(){			
			return (this.vehicleForm.colour.length >= 3)? true: false
		},
		identifyBtn()
		{
			return (this.regState && this.makeState && this.colourState)? false : true
		},
		identify(){
			return (this.$store.state.settings.identifyType == "none")? false : true
		},
		customCollectInstructions(){
			return this.$store.state.settings.customCollectInstructions 
		}
		
	}
}

</script>
<style scoped>

</style>